import { TIPTAP_DIVIDER_TYPE } from "./../../ricos-content/index.js";
import { createRicosNodeExtension } from "./../../plugin-commons/index.js";
import { Divider as Component } from "./component.js";
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    name: TIPTAP_DIVIDER_TYPE,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          lineStyle: null,
          width: null,
          alignment: null,
          containerData: null
        })
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
